import { OptionType } from '../index';
import { DateRangeField } from './DateRangeField';
import {
    DrawerChips,
    DrawerDropdown,
    DrawerInputText,
    DrawerMultiSelect,
} from './FilterDrawer.styles';
import { FilterDefinition } from './types';

export interface FilterFieldRendererProps {
    filter: FilterDefinition;
    value: unknown;
    onChange: (value: unknown) => void;
    rendererPropsOverride?: Record<string, unknown>;
}

export function FilterFieldRenderer({ filter, value, onChange, rendererPropsOverride }: FilterFieldRendererProps) {
    const merged = { ...filter.rendererProps, ...rendererPropsOverride };

    const wrapId = `filter-field-${filter.id}`;

    switch (filter.valueKind) {
        case 'multiselect':
            return (
                <DrawerMultiSelect
                    inputId={wrapId}
                    data-testid={wrapId}
                    value={value as OptionType[]}
                    onChange={(e) => onChange(e.value)}
                    options={merged.options as OptionType[]}
                    optionLabel="name"
                    display="chip"
                />
            );
        case 'dropdown':
            return (
                <DrawerDropdown
                    inputId={wrapId}
                    data-testid={wrapId}
                    value={value as OptionType}
                    onChange={(e) => onChange(e.value)}
                    options={merged.options as OptionType[]}
                    optionLabel="name"
                    showClear
                />
            );
        case 'digits-text':
            return (
                <DrawerInputText
                    id={wrapId}
                    data-testid={wrapId}
                    value={value as string}
                    onChange={(e) => onChange(e.target.value.replace(/\D/g, ''))}
                />
            );
        case 'chips':
            return (
                <div data-testid={wrapId}>
                    <DrawerChips
                        value={value as string[]}
                        onChange={(e) => onChange(e.value ?? [])}
                        addOnBlur
                        placeholder={`${filter.label} (Enter to add)`}
                    />
                </div>
            );
        case 'date-range':
            return (
                <DateRangeField
                    wrapId={wrapId}
                    value={value as (Date | null)[] | null}
                    onChange={onChange}
                />
            );
        default: {
            const _exhaustive: never = filter.valueKind;
            throw new Error(`Unhandled FilterValueKind: ${String(_exhaustive)}`);
        }
    }
}
